import { CONFIRM_COLOR, CONFIRM_ICONS, TYPE_MODAL } from '../modal-confirm-notification';

export const SESSION_EXPIRED = {
  typeModal: TYPE_MODAL.INVALID,
  title: 'Tiempo de inactividad máximo cumplido',
  valueButton: 'Aceptar',
  color: CONFIRM_COLOR.WARN,
  icon: CONFIRM_ICONS.WARNING
};
